<template>
  <div class="monthly-report-container">
    <!-- 加载状态 -->
    <div v-if="loading" class="loading-container">
      <i class="el-icon-loading"></i>
      <p>正在检查月报要求...</p>
    </div>
    
    <!-- 无需提交月报 -->
    <div v-else-if="!reportRequired" class="no-requirement">
      <i class="el-icon-info"></i>
      <h3>无需提交月报</h3>
      <p>您当月无飞行记录，无需提交月报</p>
      <el-button type="primary" @click="goBack">返回</el-button>
    </div>
    
    <!-- 月报管理界面 -->
    <div v-else class="report-management">
      <!-- 页面头部 -->
      <div class="page-header">
        <div class="header-content">
          <h2><i class="el-icon-date"></i> 月度飞行训练报告</h2>
          <p class="report-period">{{ currentYear }}年{{ currentMonth }}月</p>
        </div>
      </div>

      <!-- 标签页 -->
      <el-tabs v-model="activeTab" type="card" class="mobile-tabs">
        <!-- 填写月报 -->
        <el-tab-pane label="填写月报" name="create">
          <div class="create-report-section">
            <!-- 提示信息 -->
            <el-alert
              v-if="alreadySubmitted"
              title="您已提交本月月报，可以修改后重新提交"
              type="info"
              :closable="false"
              style="margin-bottom: 20px;">
            </el-alert>
            
            <!-- 填写时间和要求提示 -->
            <div v-if="reportSettings" class="report-settings-info">
              <el-card shadow="hover" class="settings-card">
                <div slot="header" class="settings-header">
                  <i class="el-icon-info-circle"></i> 填写须知
                </div>
                <div class="settings-content">
                  <div class="time-limit">
                    <el-row :gutter="10" type="flex" align="middle">
                      <el-col :span="4" :xs="6">
                        <span class="label"><i class="el-icon-date"></i> 填写时间：</span>
                      </el-col>
                      <el-col :span="14" :xs="12">
                        <span class="value">每月 {{ reportSettings.start_day }} 日至 {{ reportSettings.end_day }} 日</span>
                      </el-col>
                      <el-col :span="6" :xs="6">
                        <el-tag v-if="reportSettings.can_submit" type="success" effect="dark" size="small">当前可填写</el-tag>
                        <el-tag v-else type="danger" effect="dark" size="small">当前不可填写</el-tag>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="requirements" v-if="reportSettings.requirements">
                    <el-row :gutter="10" class="requirement-row">
                      <el-col :span="4" :xs="6">
                        <span class="label"><i class="el-icon-document-checked"></i> 填写要求：</span>
                      </el-col>
                      <el-col :span="20" :xs="18">
                        <span class="value">{{ reportSettings.requirements }}</span>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-card>
            </div>
            
            <!-- 月报表单 -->
            <el-form ref="reportForm" :model="reportForm" label-width="140px" size="medium">
              <!-- 本月飞行情况 -->
              <el-card shadow="hover" style="margin-bottom: 20px;">
                <div slot="header" class="card-header">
                  <span><i class="el-icon-takeoff-filling"></i> 本月飞行情况</span>
                </div>

                
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="训练基地" prop="training_base">
                      <el-input v-model="reportForm.training_base" placeholder="请输入训练基地" style="width: 100%;">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="当月飞行时间" prop="monthly_flight_hours">
                      <div class="time-input-group">
                        <div class="time-input-wrapper">
                          <label class="time-label">小时</label>
                          <el-input-number
                            v-model="reportForm.monthly_flight_hours_input"
                            :min="0"
                            :max="999"
                            placeholder="0">
                          </el-input-number>
                        </div>
                        <span class="time-separator">+</span>
                        <div class="time-input-wrapper">
                          <label class="time-label">分钟</label>
                          <el-input-number
                            v-model="reportForm.monthly_flight_minutes_input"
                            :min="0"
                            :max="59"
                            placeholder="0">
                          </el-input-number>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="本月起落次数" prop="monthly_landings">
                      <el-input-number
                        v-model="reportForm.monthly_landings"
                        :min="0"
                        :max="9999"
                        style="width: 100%;">
                        <template slot="append">次</template>
                      </el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-card>
              
              <!-- 真机训练整体情况 -->
              <el-card shadow="hover" style="margin-bottom: 20px;">
                <div slot="header" class="card-header">
                  <span><i class="el-icon-ship"></i> 真机训练整体情况</span>
                </div>
                
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="真机总时间" prop="total_aircraft_hours">
                      <div class="time-input-group">
                        <div class="time-input-wrapper">
                          <label class="time-label">小时</label>
                          <el-input-number
                            v-model="reportForm.total_aircraft_hours_input"
                            :min="0"
                            :max="9999"
                            placeholder="0">
                          </el-input-number>
                        </div>
                        <span class="time-separator">+</span>
                        <div class="time-input-wrapper">
                          <label class="time-label">分钟</label>
                          <el-input-number
                            v-model="reportForm.total_aircraft_minutes_input"
                            :min="0"
                            :max="59"
                            placeholder="0">
                          </el-input-number>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="机长时间" prop="captain_hours">
                      <div class="time-input-group">
                        <div class="time-input-wrapper">
                          <label class="time-label">小时</label>
                          <el-input-number
                            v-model="reportForm.captain_hours_input"
                            :min="0"
                            :max="9999"
                            placeholder="0">
                          </el-input-number>
                        </div>
                        <span class="time-separator">+</span>
                        <div class="time-input-wrapper">
                          <label class="time-label">分钟</label>
                          <el-input-number
                            v-model="reportForm.captain_minutes_input"
                            :min="0"
                            :max="59"
                            placeholder="0">
                          </el-input-number>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="带飞时间" prop="instructor_hours">
                      <div class="time-input-group">
                        <div class="time-input-wrapper">
                          <label class="time-label">小时</label>
                          <el-input-number
                            v-model="reportForm.instructor_hours_input"
                            :min="0"
                            :max="9999"
                            placeholder="0">
                          </el-input-number>
                        </div>
                        <span class="time-separator">+</span>
                        <div class="time-input-wrapper">
                          <label class="time-label">分钟</label>
                          <el-input-number
                            v-model="reportForm.instructor_minutes_input"
                            :min="0"
                            :max="59"
                            placeholder="0">
                          </el-input-number>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="单飞时间" prop="solo_hours">
                      <div class="time-input-group">
                        <div class="time-input-wrapper">
                          <label class="time-label">小时</label>
                          <el-input-number
                            v-model="reportForm.solo_hours_input"
                            :min="0"
                            :max="9999"
                            placeholder="0">
                          </el-input-number>
                        </div>
                        <span class="time-separator">+</span>
                        <div class="time-input-wrapper">
                          <label class="time-label">分钟</label>
                          <el-input-number
                            v-model="reportForm.solo_minutes_input"
                            :min="0"
                            :max="59"
                            placeholder="0">
                          </el-input-number>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="转场时间" prop="cross_country_hours">
                      <div class="time-input-group">
                        <div class="time-input-wrapper">
                          <label class="time-label">小时</label>
                          <el-input-number
                            v-model="reportForm.cross_country_hours_input"
                            :min="0"
                            :max="9999"
                            placeholder="0">
                          </el-input-number>
                        </div>
                        <span class="time-separator">+</span>
                        <div class="time-input-wrapper">
                          <label class="time-label">分钟</label>
                          <el-input-number
                            v-model="reportForm.cross_country_minutes_input"
                            :min="0"
                            :max="59"
                            placeholder="0">
                          </el-input-number>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="仪表时间" prop="instrument_hours">
                      <div class="time-input-group">
                        <div class="time-input-wrapper">
                          <label class="time-label">小时</label>
                          <el-input-number
                            v-model="reportForm.instrument_hours_input"
                            :min="0"
                            :max="9999"
                            placeholder="0">
                          </el-input-number>
                        </div>
                        <span class="time-separator">+</span>
                        <div class="time-input-wrapper">
                          <label class="time-label">分钟</label>
                          <el-input-number
                            v-model="reportForm.instrument_minutes_input"
                            :min="0"
                            :max="59"
                            placeholder="0">
                          </el-input-number>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="真机起落次数" prop="total_aircraft_landings">
                      <el-input-number
                        v-model="reportForm.total_aircraft_landings"
                        :min="0"
                        :max="99999"
                        style="width: 100%;">
                        <template slot="append">次</template>
                      </el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="加时小时数" prop="overtime_hours">
                      <div class="time-input-group">
                        <div class="time-input-wrapper">
                          <label class="time-label">小时</label>
                          <el-input-number
                            v-model="reportForm.overtime_hours_input"
                            :min="0"
                            :max="9999"
                            placeholder="0">
                          </el-input-number>
                        </div>
                        <span class="time-separator">+</span>
                        <div class="time-input-wrapper">
                          <label class="time-label">分钟</label>
                          <el-input-number
                            v-model="reportForm.overtime_minutes_input"
                            :min="0"
                            :max="59"
                            placeholder="0">
                          </el-input-number>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-card>
              
              <!-- 模拟机训练情况 -->
              <el-card shadow="hover" style="margin-bottom: 20px;">
                <div slot="header" class="card-header">
                  <span><i class="el-icon-monitor"></i> 模拟机训练情况</span>
                </div>
                
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="模拟机时间" prop="simulator_hours">
                      <div class="time-input-group">
                        <div class="time-input-wrapper">
                          <label class="time-label">小时</label>
                          <el-input-number
                            v-model="reportForm.simulator_hours_input"
                            :min="0"
                            :max="9999"
                            placeholder="0">
                          </el-input-number>
                        </div>
                        <span class="time-separator">+</span>
                        <div class="time-input-wrapper">
                          <label class="time-label">分钟</label>
                          <el-input-number
                            v-model="reportForm.simulator_minutes_input"
                            :min="0"
                            :max="59"
                            placeholder="0">
                          </el-input-number>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="模拟机起落次数" prop="simulator_landings">
                      <el-input-number
                        v-model="reportForm.simulator_landings"
                        :min="0"
                        :max="99999"
                        style="width: 100%;">
                        <template slot="append">次</template>
                      </el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-card>
              
              <!-- 训练阶段和预计回国日期 -->
              <el-card shadow="hover" style="margin-bottom: 20px;">
                <div slot="header" class="card-header">
                  <span><i class="el-icon-date"></i> 训练阶段和预计回国日期</span>
                </div>
                
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="当前训练阶段" prop="training_stage">
                      <el-select 
                        v-model="reportForm.training_stage" 
                        placeholder="请选择训练阶段" 
                        style="width: 100%;">
                        <el-option
                          v-for="item in trainingStages"
                          :key="item.name"
                          :label="item.name"
                          :value="item.name">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="预计回国日期" prop="expected_return_date">
                      <el-date-picker
                        v-model="reportForm.expected_return_date"
                        type="date"
                        placeholder="选择预计回国日期"
                        format="yyyy年MM月dd日"
                        value-format="yyyy-MM-dd"
                        style="width: 100%;"
                        :picker-options="{
                          disabledDate(time) {
                            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                          }
                        }">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12"> 
                    <el-form-item label="开飞日期" prop="flight_start_date"> 
                      <el-date-picker
                        v-model="reportForm.flight_start_date"
                        type="date"
                        placeholder="选择开飞日期"
                        format="yyyy年MM月dd日"
                        value-format="yyyy-MM-dd"
                        style="width: 100%;">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12"> 
                    <el-form-item label="停飞日期" prop="suspension_date"> 
                      <el-date-picker
                        v-model="reportForm.suspension_date"
                        type="date"
                        placeholder="选择停飞日期"
                        format="yyyy年MM月dd日"
                        value-format="yyyy-MM-dd"
                        style="width: 100%;">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-card>
              
              <!-- 考试相关情况 -->
              <el-card shadow="hover" style="margin-bottom: 20px;">
                <div slot="header" class="card-header">
                  <span><i class="el-icon-document-checked"></i> 考试相关情况</span>
                </div>
                
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="理论考试不通过次数" prop="theory_exam_failures">
                      <el-input-number
                        v-model="reportForm.theory_exam_failures"
                        :min="0"
                        :max="999"
                        style="width: 100%;">
                        <template slot="append">次</template>
                      </el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12">
                    <el-form-item label="实践考试不通过次数" prop="practical_exam_failures">
                      <el-input-number
                        v-model="reportForm.practical_exam_failures"
                        :min="0"
                        :max="999"
                        style="width: 100%;">
                        <template slot="append">次</template>
                      </el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-card>
              
              
              <!-- 提交按钮 -->
              <div class="submit-section">
                <el-button-group>
                  <el-button 
                    type="primary" 
                    icon="el-icon-check" 
                    @click="submitReport" 
                    :loading="submitting"
                    :disabled="reportSettings && !reportSettings.can_submit"
                    size="large">
                    提交月报
                  </el-button>
                  <el-button 
                    icon="el-icon-refresh" 
                    @click="resetForm"
                    size="large">
                    重置
                  </el-button>
                </el-button-group>
                <div v-if="reportSettings && !reportSettings.can_submit" class="submit-tip">
                  当前不在填写时间范围内，无法提交
                </div>
              </div>
            </el-form>
          </div>
        </el-tab-pane>
        
        <!-- 历史记录 -->
        <el-tab-pane label="历史记录" name="history">
          <div class="history-section">
            <div class="section-header">
              <span>月报历史记录</span>
              <el-button type="text" icon="el-icon-refresh" @click="loadReportHistory" size="small">刷新</el-button>
            </div>
            
            <el-table :data="reportHistory" v-loading="loadingHistory" stripe size="medium" style="width: 100%;">
              <el-table-column prop="month_display" label="月份" width="120"></el-table-column>
              <el-table-column prop="monthly_flight_hours" label="当月飞行时间" width="140">
                <template slot-scope="scope">
                  {{ scope.row.monthly_flight_hours || 0 }} 小时
                </template>
              </el-table-column>
              <el-table-column prop="monthly_landings" label="当月起落次数" width="140">
                <template slot-scope="scope">
                  {{ scope.row.monthly_landings || 0 }} 次
                </template>
              </el-table-column>
              <el-table-column prop="submitted_at" label="提交时间" width="160"></el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" icon="el-icon-view" @click="viewReportDetail(scope.row)">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
            
            <div class="pagination-wrapper" v-if="reportHistory.length > 0">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :current-page="pagination.page"
                :page-sizes="[5, 10, 20]"
                :page-size="pagination.pageSize"
                :layout="isMobile ? 'prev, pager, next' : 'total, sizes, prev, pager, next'"
                :total="pagination.total"
                small>
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    
    <!-- 详情对话框 -->
    <el-dialog
      title="月报详情"
      :visible.sync="detailDialogVisible"
      :width="isMobile ? '95%' : '70%'"
      :fullscreen="isMobile">
      <div v-if="selectedReport" class="report-detail">
        <div class="detail-summary">
          <h4>{{ selectedReport.report_year }}年{{ selectedReport.report_month }}月训练报告</h4>
          <p>提交时间：{{ selectedReport.submitted_at }}</p>
        </div>
        
        <el-col :span="24">
          <h5>训练基地</h5>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="训练基地">{{ selectedReport.training_base || '未设置' }}</el-descriptions-item>
          </el-descriptions>
        </el-col>
        
        <el-row :gutter="20">
          <el-col :span="24">
            <h5>本月情况</h5>
            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="当月飞行时间">{{ selectedReport.monthly_flight_display || formatMinutesToDisplay(selectedReport.monthly_flight_minutes) || '0小时0分钟' }}</el-descriptions-item>
              <el-descriptions-item label="本月起落次数">{{ selectedReport.monthly_landings }} 次</el-descriptions-item>
            </el-descriptions>
          </el-col>
          
          <el-col :span="24" style="margin-top: 20px;">
            <h5>真机训练情况</h5>
            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="真机总时间">{{ selectedReport.total_aircraft_display || formatMinutesToDisplay(selectedReport.total_aircraft_minutes) || '0小时0分钟' }}</el-descriptions-item>
              <el-descriptions-item label="机长时间">{{ selectedReport.captain_display || formatMinutesToDisplay(selectedReport.captain_minutes) || '0小时0分钟' }}</el-descriptions-item>
              <el-descriptions-item label="带飞时间">{{ selectedReport.instructor_display || formatMinutesToDisplay(selectedReport.instructor_minutes) || '0小时0分钟' }}</el-descriptions-item>
              <el-descriptions-item label="单飞时间">{{ selectedReport.solo_display || formatMinutesToDisplay(selectedReport.solo_minutes) || '0小时0分钟' }}</el-descriptions-item>
              <el-descriptions-item label="转场时间">{{ selectedReport.cross_country_display || formatMinutesToDisplay(selectedReport.cross_country_minutes) || '0小时0分钟' }}</el-descriptions-item>
              <el-descriptions-item label="仪表时间">{{ selectedReport.instrument_display || formatMinutesToDisplay(selectedReport.instrument_minutes) || '0小时0分钟' }}</el-descriptions-item>
              <el-descriptions-item label="真机起落次数">{{ selectedReport.total_aircraft_landings }} 次</el-descriptions-item>
              <el-descriptions-item label="加时小时数">{{ selectedReport.overtime_display || formatMinutesToDisplay(selectedReport.overtime_minutes) || '0小时0分钟' }}</el-descriptions-item>
            </el-descriptions>
          </el-col>
          
          <el-col :span="24" style="margin-top: 20px;">
            <h5>模拟机训练情况</h5>
            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="模拟机时间">{{ selectedReport.simulator_display || formatMinutesToDisplay(selectedReport.simulator_minutes) || '0小时0分钟' }}</el-descriptions-item>
              <el-descriptions-item label="模拟机起落次数">{{ selectedReport.simulator_landings }} 次</el-descriptions-item>
            </el-descriptions>
          </el-col>
          
          <el-col :span="24" style="margin-top: 20px;">
            <h5>训练汇总</h5>
            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="累计训练时间">{{ selectedReport.total_training_display || formatMinutesToDisplay(selectedReport.total_training_minutes) || '0小时0分钟' }}</el-descriptions-item>
              <el-descriptions-item label="累计起落次数">{{ selectedReport.total_landings }} 次</el-descriptions-item>
            </el-descriptions>
          </el-col>

          <!--训练阶段和预计回国日期-->
          <el-col :span="24" style="margin-top: 20px;">
            <h5>训练阶段和预计回国日期</h5>
            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="当前训练阶段">{{ selectedReport.training_stage || '未设置' }}</el-descriptions-item>
              <el-descriptions-item label="预计回国日期">{{ selectedReport.expected_return_date || '未设置' }}</el-descriptions-item>
            </el-descriptions>
          </el-col>

          <el-col :span="24" style="margin-top: 20px;">
            <h5>开飞和停飞</h5>
            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="开飞日期">{{ selectedReport.flight_start_date || '未设置' }}</el-descriptions-item>
              <el-descriptions-item label="停飞日期">{{ selectedReport.suspension_date || '未设置' }}</el-descriptions-item>
            </el-descriptions>
          </el-col>
          
          <el-col :span="24" style="margin-top: 20px;">
            <h5>考试相关情况</h5>
            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="理论考试不通过次数">{{ selectedReport.theory_exam_failures || 0 }} 次</el-descriptions-item>
              <el-descriptions-item label="实践考试不通过次数">{{ selectedReport.practical_exam_failures || 0 }} 次</el-descriptions-item>
            </el-descriptions>
          </el-col>
        </el-row>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDetailDialog">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../api/index"
import axiosInstance from "../../api/axiosInstance"

export default {
  name: 'MonthlyReport',
  data() {
    return {
      loading: true,
      reportRequired: false,
      alreadySubmitted: false,
      activeTab: 'create',
      submitting: false,
      loadingHistory: false,
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth(),
      isMobile: false,
      reportSettings: null,
      trainingStages: [],
      reportForm: {
        training_base: '',
        report_year: new Date().getFullYear(),
        report_month: new Date().getMonth(),
        // 分钟数据（实际存储）
        monthly_flight_minutes: 0,
        total_aircraft_minutes: 0,
        captain_minutes: 0,
        instructor_minutes: 0,
        solo_minutes: 0,
        cross_country_minutes: 0,
        instrument_minutes: 0,
        simulator_minutes: 0,
        // 输入字段（小时和分钟分开输入）
        monthly_flight_hours_input: 0,
        monthly_flight_minutes_input: 0,
        total_aircraft_hours_input: 0,
        total_aircraft_minutes_input: 0,
        captain_hours_input: 0,
        captain_minutes_input: 0,
        instructor_hours_input: 0,
        instructor_minutes_input: 0,
        solo_hours_input: 0,
        solo_minutes_input: 0,
        cross_country_hours_input: 0,
        cross_country_minutes_input: 0,
        instrument_hours_input: 0,
        instrument_minutes_input: 0,
        simulator_hours_input: 0,
        simulator_minutes_input: 0,
        // 考试相关字段
        overtime_minutes: 0,
        overtime_hours_input: 0,
        overtime_minutes_input: 0,
        theory_exam_failures: 0,
        practical_exam_failures: 0,
        // 其他字段
        monthly_landings: 0,
        total_aircraft_landings: 0,
        simulator_landings: 0,
        expected_return_date: '',
        training_stage: '',
        flight_start_date: '',
        suspension_date: ''
      },
      reportHistory: [],
      pagination: { page: 1, pageSize: 10, total: 0 },
      detailDialogVisible: false,
      selectedReport: null
    }
  },
  
  computed: {
    totalTrainingMinutes() {
      return (this.reportForm.total_aircraft_minutes || 0) + (this.reportForm.simulator_minutes || 0)
    },
    totalTrainingHours() {
      return (this.totalTrainingMinutes / 60).toFixed(2)
    },
    totalLandings() {
      return (this.reportForm.total_aircraft_landings || 0) + (this.reportForm.simulator_landings || 0)
    }
  },
  
  async mounted() {
    // 设置当前月和年为上一个月
    this.currentYear = new Date().getFullYear()
    this.currentMonth = new Date().getMonth()
    console.log(this.currentYear)
    console.log(this.currentMonth)
    if (this.currentMonth === 0) {
      this.currentYear = this.currentYear - 1
      this.currentMonth = 12
    }
    if(this.reportForm.report_month==0){
      this.reportForm.report_month=12
      this.reportForm.report_year=this.reportForm.report_year-1
    }
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    await this.checkReportRequirement()
    await this.loadReportSettings()
    await this.loadTrainingStages()
  },
  
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    
    // 将分钟转换为x小时x分钟显示格式
    formatMinutesToDisplay(minutes) {
      if (!minutes) return "0小时0分钟"
      const hours = Math.floor(minutes / 60)
      const mins = minutes % 60
      return `${hours}小时${mins}分钟`
    },
    
    // 将小时和分钟输入转换为总分钟数
    hoursMinutesToMinutes(hours, minutes) {
      return (parseInt(hours) || 0) * 60 + (parseInt(minutes) || 0)
    },
    
    // 将分钟数转换为小时和分钟输入
    minutesToHoursMinutes(totalMinutes) {
      const hours = Math.floor(totalMinutes / 60)
      const minutes = totalMinutes % 60
      return { hours, minutes }
    },
    
    // 更新分钟数据（当输入字段变化时调用）
    updateMinutesFromInputs() {
      this.reportForm.monthly_flight_minutes = this.hoursMinutesToMinutes(
        this.reportForm.monthly_flight_hours_input, 
        this.reportForm.monthly_flight_minutes_input
      )
      this.reportForm.total_aircraft_minutes = this.hoursMinutesToMinutes(
        this.reportForm.total_aircraft_hours_input, 
        this.reportForm.total_aircraft_minutes_input
      )
      this.reportForm.captain_minutes = this.hoursMinutesToMinutes(
        this.reportForm.captain_hours_input, 
        this.reportForm.captain_minutes_input
      )
      this.reportForm.instructor_minutes = this.hoursMinutesToMinutes(
        this.reportForm.instructor_hours_input, 
        this.reportForm.instructor_minutes_input
      )
      this.reportForm.solo_minutes = this.hoursMinutesToMinutes(
        this.reportForm.solo_hours_input, 
        this.reportForm.solo_minutes_input
      )
      this.reportForm.cross_country_minutes = this.hoursMinutesToMinutes(
        this.reportForm.cross_country_hours_input, 
        this.reportForm.cross_country_minutes_input
      )
      this.reportForm.instrument_minutes = this.hoursMinutesToMinutes(
        this.reportForm.instrument_hours_input, 
        this.reportForm.instrument_minutes_input
      )
      this.reportForm.simulator_minutes = this.hoursMinutesToMinutes(
        this.reportForm.simulator_hours_input, 
        this.reportForm.simulator_minutes_input
      )
      this.reportForm.overtime_minutes = this.hoursMinutesToMinutes(
        this.reportForm.overtime_hours_input, 
        this.reportForm.overtime_minutes_input
      )
    },
    
    async loadReportSettings() {
       try {
         const response = await axiosInstance.get(api.getReportSettings('monthly'))
         if (response.data.code === 200) {
           this.reportSettings = response.data.data
         }
       } catch (error) {
         console.error('加载月报设置失败:', error)
       }
     },
    
    async checkReportRequirement() {
      try {
        this.loading = true
        const params = { year: this.currentYear, month: this.currentMonth }
        const response = await axiosInstance.get(api.checkMonthlyReportRequired, { params })
        
        if (response.data.status === 'success') {
          this.reportRequired = response.data.data.required
          this.alreadySubmitted = response.data.data.already_submitted

          if (this.alreadySubmitted) {
            await this.loadExistingReport()
          }
        } else if (response.data.status === 'info') {
          this.reportRequired = false
        }
      } catch (error) {
        this.$message.error('检查月报要求失败: ' + error.message)
      } finally {
        this.loading = false
      }
    },
    
    async loadExistingReport() {
      try {
        const params = { year: this.currentYear, month: this.currentMonth }
        const response = await axiosInstance.get(api.getMonthlyReport, { params })
        
        if (response.data.status === 'success') {
          const data = response.data.data
          // 设置分钟数据
          this.reportForm.monthly_flight_minutes = data.monthly_flight_minutes || 0
          this.reportForm.total_aircraft_minutes = data.total_aircraft_minutes || 0
          this.reportForm.captain_minutes = data.captain_minutes || 0
          this.reportForm.instructor_minutes = data.instructor_minutes || 0
          this.reportForm.solo_minutes = data.solo_minutes || 0
          this.reportForm.cross_country_minutes = data.cross_country_minutes || 0
          this.reportForm.instrument_minutes = data.instrument_minutes || 0
          this.reportForm.simulator_minutes = data.simulator_minutes || 0
          
          // 设置输入字段
          const monthlyTime = this.minutesToHoursMinutes(data.monthly_flight_minutes || 0)
          this.reportForm.monthly_flight_hours_input = monthlyTime.hours
          this.reportForm.monthly_flight_minutes_input = monthlyTime.minutes
          
          const aircraftTime = this.minutesToHoursMinutes(data.total_aircraft_minutes || 0)
          this.reportForm.total_aircraft_hours_input = aircraftTime.hours
          this.reportForm.total_aircraft_minutes_input = aircraftTime.minutes
          
          const captainTime = this.minutesToHoursMinutes(data.captain_minutes || 0)
          this.reportForm.captain_hours_input = captainTime.hours
          this.reportForm.captain_minutes_input = captainTime.minutes
          
          const instructorTime = this.minutesToHoursMinutes(data.instructor_minutes || 0)
          this.reportForm.instructor_hours_input = instructorTime.hours
          this.reportForm.instructor_minutes_input = instructorTime.minutes
          
          const soloTime = this.minutesToHoursMinutes(data.solo_minutes || 0)
          this.reportForm.solo_hours_input = soloTime.hours
          this.reportForm.solo_minutes_input = soloTime.minutes
          
          const crossCountryTime = this.minutesToHoursMinutes(data.cross_country_minutes || 0)
          this.reportForm.cross_country_hours_input = crossCountryTime.hours
          this.reportForm.cross_country_minutes_input = crossCountryTime.minutes
          
          const instrumentTime = this.minutesToHoursMinutes(data.instrument_minutes || 0)
          this.reportForm.instrument_hours_input = instrumentTime.hours
          this.reportForm.instrument_minutes_input = instrumentTime.minutes
          
          const simulatorTime = this.minutesToHoursMinutes(data.simulator_minutes || 0)
          this.reportForm.simulator_hours_input = simulatorTime.hours
          this.reportForm.simulator_minutes_input = simulatorTime.minutes
          
          // 设置其他字段
          this.reportForm.training_base = data.training_base || ''
          this.reportForm.monthly_landings = data.monthly_landings || 0
          this.reportForm.total_aircraft_landings = data.total_aircraft_landings || 0
          this.reportForm.simulator_landings = data.simulator_landings || 0
          this.reportForm.expected_return_date = data.expected_return_date || ''
          this.reportForm.training_stage = data.training_stage || ''
          this.reportForm.flight_start_date = data.flight_start_date || ''
          this.reportForm.suspension_date = data.suspension_date || ''
          
          // 设置考试相关字段
          this.reportForm.overtime_minutes = data.overtime_minutes || 0
          const overtimeTime = this.minutesToHoursMinutes(data.overtime_minutes || 0)
          this.reportForm.overtime_hours_input = overtimeTime.hours
          this.reportForm.overtime_minutes_input = overtimeTime.minutes
          this.reportForm.theory_exam_failures = data.theory_exam_failures || 0
          this.reportForm.practical_exam_failures = data.practical_exam_failures || 0
        }
      } catch (error) {
        console.warn('加载现有月报失败:', error)
      }
    },
    
    async loadTrainingStages() {
      try {
        const response = await axiosInstance.get(api.getTrainingStages)
        if (response.data.status === 'success') {
          this.trainingStages = response.data.data
        }
      } catch (error) {
        console.error('加载训练阶段失败:', error)
        this.$message.error('加载训练阶段失败')
      }
    },
    
    async submitReport() {
      // 更新分钟数据
      this.updateMinutesFromInputs()
      
      try {
        await this.$confirm('确定要提交月报吗？', '确认提交', {
          confirmButtonText: '确定提交',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        this.submitting = true
        
        // 准备提交数据（使用分钟数据）
        const submitData = {
          ...this.reportForm,
          // 确保使用分钟数据
          monthly_flight_minutes: this.reportForm.monthly_flight_minutes,
          total_aircraft_minutes: this.reportForm.total_aircraft_minutes,
          captain_minutes: this.reportForm.captain_minutes,
          instructor_minutes: this.reportForm.instructor_minutes,
          solo_minutes: this.reportForm.solo_minutes,
          cross_country_minutes: this.reportForm.cross_country_minutes,
          instrument_minutes: this.reportForm.instrument_minutes,
          simulator_minutes: this.reportForm.simulator_minutes,
          overtime_minutes: this.reportForm.overtime_minutes,
          theory_exam_failures: this.reportForm.theory_exam_failures,
          practical_exam_failures: this.reportForm.practical_exam_failures
        }
        
        const response = await axiosInstance.post(api.submitMonthlyReport, submitData)
        
        if (response.data.status === 'success') {
          this.$message.success('月报提交成功')
          this.alreadySubmitted = true
          this.loadReportHistory()
        } else {
          this.$message.error(response.data.message)
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('提交失败: ' + error.message)
        }
      } finally {
        this.submitting = false
      }
    },
    
    resetForm() {
      this.$confirm('确定要重置表单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.reportForm = {
          training_base: '',
          report_year: this.currentYear,
          report_month: this.currentMonth,
          monthly_flight_hours: 0,
          monthly_landings: 0,
          total_aircraft_hours: 0,
          captain_hours: 0,
          instructor_hours: 0,
          solo_hours: 0,
          cross_country_hours: 0,
          instrument_hours: 0,
          total_aircraft_landings: 0,
          simulator_hours: 0,
          simulator_landings: 0,
          expected_return_date: '',
          training_stage: '',
          flight_start_date: '',
          suspension_date: '',
          overtime_minutes: 0,
          overtime_hours_input: 0,
          overtime_minutes_input: 0,
          theory_exam_failures: 0,
          practical_exam_failures: 0
        }
        this.$message.success('表单已重置')
      }).catch(() => {})
    },
    
    async loadReportHistory() {
      try {
        this.loadingHistory = true
        const params = { 
          page: this.pagination.page, 
          page_size: this.pagination.pageSize
        }
        const response = await axiosInstance.get(api.getMonthlyReportsList, { params })
        
        if (response.data.status === 'success') {
          this.reportHistory = response.data.data.items
          this.pagination.total = response.data.data.total
        }
      } catch (error) {
        this.$message.error('加载历史记录失败: ' + error.message)
      } finally {
        this.loadingHistory = false
      }
    },
    
    async viewReportDetail(report) {
      try {
        const params = { year: report.report_year, month: report.report_month }
        const response = await axiosInstance.get(api.getMonthlyReport, { params })
        
        if (response.data.status === 'success') {
          this.selectedReport = response.data.data
          this.detailDialogVisible = true
        }
      } catch (error) {
        this.$message.error('获取月报详情失败: ' + error.message)
      }
    },
    
    closeDetailDialog() {
      this.detailDialogVisible = false
      this.selectedReport = null
    },
    
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.loadReportHistory()
    },
    
    handlePageChange(page) {
      this.pagination.page = page
      this.loadReportHistory()
    },
    
    goBack() {
      this.$router.go(-1)
    }
  },
  
  watch: {
    activeTab(newTab) {
      if (newTab === 'history' && this.reportHistory.length === 0) {
        this.loadReportHistory()
      }
    },
    
    // 监听时间输入字段变化，自动更新分钟数据
    'reportForm.monthly_flight_hours_input'() { this.updateMinutesFromInputs() },
    'reportForm.monthly_flight_minutes_input'() { this.updateMinutesFromInputs() },
    'reportForm.total_aircraft_hours_input'() { this.updateMinutesFromInputs() },
    'reportForm.total_aircraft_minutes_input'() { this.updateMinutesFromInputs() },
    'reportForm.captain_hours_input'() { this.updateMinutesFromInputs() },
    'reportForm.captain_minutes_input'() { this.updateMinutesFromInputs() },
    'reportForm.instructor_hours_input'() { this.updateMinutesFromInputs() },
    'reportForm.instructor_minutes_input'() { this.updateMinutesFromInputs() },
    'reportForm.solo_hours_input'() { this.updateMinutesFromInputs() },
    'reportForm.solo_minutes_input'() { this.updateMinutesFromInputs() },
    'reportForm.cross_country_hours_input'() { this.updateMinutesFromInputs() },
    'reportForm.cross_country_minutes_input'() { this.updateMinutesFromInputs() },
    'reportForm.instrument_hours_input'() { this.updateMinutesFromInputs() },
    'reportForm.instrument_minutes_input'() { this.updateMinutesFromInputs() },
    'reportForm.simulator_hours_input'() { this.updateMinutesFromInputs() },
    'reportForm.simulator_minutes_input'() { this.updateMinutesFromInputs() },
    'reportForm.overtime_hours_input'() { this.updateMinutesFromInputs() },
    'reportForm.overtime_minutes_input'() { this.updateMinutesFromInputs() }
  }
}
</script>

<style scoped>
.validation-error {
  border-color: #f56c6c !important;
}

.validation-info {
  margin-top: 12px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-radius: 8px;
  border: 1px solid #bae6fd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
}

.validation-info:hover {
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  transform: translateY(-1px);
}

.calculated-value {
  flex: 1;
  font-size: 13px;
  color: #0369a1;
  font-weight: 500;
  line-height: 1.4;
}

.sync-btn {
  padding: 6px 12px;
  color: #409eff;
  font-size: 12px;
  font-weight: 600;
  background: #ffffff;
  border: 1px solid #409eff;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.sync-btn:hover {
  color: #ffffff;
  background: #409eff;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.time-input-group {
  display: flex;
  align-items: flex-end;
  width: 100%;
  gap: 12px;
  padding: 8px;
  background: #fafbfc;
  border-radius: 6px;
  border: 1px solid #e4e7ed;
  transition: all 0.3s ease;
}

.time-input-group:hover {
  border-color: #c0c4cc;
  background: #f8f9fa;
}

.time-input-group:focus-within {
  border-color: #409eff;
  background: #ffffff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

.time-input-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.time-label {
  font-size: 13px;
  color: #606266;
  margin-bottom: 6px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  background: linear-gradient(135deg, #409eff, #67c23a);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.time-input-wrapper .el-input-number {
  width: 100%;
}

.time-input-wrapper .el-input-number .el-input__inner {
  text-align: center;
  font-weight: 600;
  font-size: 16px;
  border: 2px solid transparent;
  background: #ffffff;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.time-input-wrapper .el-input-number .el-input__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.time-input-wrapper .el-input-number.validation-error .el-input__inner {
  border-color: #f56c6c;
  background: #fef0f0;
}

.time-separator {
  font-size: 20px;
  font-weight: bold;
  color: #409eff;
  margin: 0 4px;
  align-self: center;
  margin-bottom: 16px;
  text-shadow: 0 1px 2px rgba(64, 158, 255, 0.3);
  transition: all 0.3s ease;
}

.time-input-group:hover .time-separator {
  color: #67c23a;
  transform: scale(1.1);
}
/* 基础布局 */
.monthly-report-container {
  padding: 16px;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8f4fd 100%);
}

/* 表单样式优化 */
.el-form {
  background: transparent;
}

.el-form-item {
  margin-bottom: 24px;
}

.el-form-item__label {
  font-weight: 600;
  color: #303133;
  font-size: 14px;
  line-height: 1.5;
  padding-bottom: 8px;
}

.el-form-item__content {
  position: relative;
}

/* 输入框样式统一 */
.el-input__inner,
.el-textarea__inner,
.el-select .el-input__inner {
  border-radius: 6px;
  border: 2px solid #e4e7ed;
  transition: all 0.3s ease;
  font-size: 14px;
  padding: 12px 15px;
}

.el-input__inner:focus,
.el-textarea__inner:focus,
.el-select .el-input__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.el-input__inner:hover,
.el-textarea__inner:hover,
.el-select .el-input__inner:hover {
  border-color: #c0c4cc;
}

/* 数字输入框样式 */
.el-input-number {
  width: 100%;
}

.el-input-number .el-input__inner {
  text-align: center;
  font-weight: 500;
}

/* 选择器样式 */
.el-select {
  width: 100%;
}

/* 日期选择器样式 */
.el-date-editor {
  width: 100%;
}

.el-date-editor .el-input__inner {
  padding-left: 35px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #909399;
}

.loading-container i {
  font-size: 32px;
  margin-bottom: 15px;
}

.no-requirement {
  text-align: center;
  padding: 60px 20px;
  color: #606266;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.no-requirement i {
  font-size: 48px;
  color: #409eff;
  margin-bottom: 15px;
}

.no-requirement h3 {
  margin: 15px 0;
  color: #303133;
}

/* 页面头部 */
.page-header {
  margin-bottom: 15px;
  padding: 15px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-content h2 {
  margin: 0 0 8px 0;
  color: #303133;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
}

.report-period {
  margin: 0;
  color: #909399;
  font-size: 13px;
}

/* 标签页 */
.mobile-tabs {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 卡片头部 */
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  color: #303133;
  font-size: 16px;
  padding: 2px 0;
}

.card-header i {
  font-size: 18px;
  color: #409eff;
  text-shadow: 0 1px 2px rgba(64, 158, 255, 0.3);
}

/* 卡片样式优化 */
.el-card {
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #e4e7ed;
  transition: all 0.3s ease;
}

.el-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.el-card .el-card__header {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-bottom: 2px solid #e4e7ed;
  padding: 18px 20px;
}

.el-card .el-card__body {
  padding: 24px 20px;
}

/* 填写须知样式 */
.report-settings-info {
  margin-bottom: 20px;
}

.settings-card {
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s;
}

.settings-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}

.settings-header {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.settings-header i {
  color: #409EFF;
  margin-right: 5px;
}

.settings-content {
  padding: 5px 0;
}

.time-limit {
  margin-bottom: 15px;
}

.requirement-row {
  margin-top: 10px;
}

.label {
  font-weight: 500;
  color: #606266;
  display: inline-flex;
  align-items: center;
}

.label i {
  margin-right: 5px;
  color: #409EFF;
}

.value {
  color: #303133;
  line-height: 1.5;
}

/* 提交区域 */
.submit-section {
  text-align: center;
  padding: 32px 24px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 12px;
  margin-top: 32px;
  border: 2px solid #e4e7ed;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.submit-section .el-button-group {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.submit-section .el-button {
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  min-width: 140px;
  transition: all 0.3s ease;
}

.submit-section .el-button--primary {
  background: linear-gradient(135deg, #409eff 0%, #67c23a 100%);
  border: none;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.submit-section .el-button--primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(64, 158, 255, 0.4);
}

.submit-section .el-button--primary:disabled {
  background: #c0c4cc;
  transform: none;
  box-shadow: none;
}

.submit-tip {
  margin-top: 16px;
  color: #f56c6c;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;
  background: #fef0f0;
  border-radius: 6px;
  border: 1px solid #fbc4c4;
  display: inline-block;
}

/* 区块头部 */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: white;
  border-radius: 8px;
  margin-bottom: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* 分页 */
.pagination-wrapper {
  margin-top: 15px;
  text-align: center;
}

/* 详情对话框 */
.report-detail h4 {
  margin: 0 0 10px 0;
  color: #303133;
  font-size: 16px;
}

.detail-summary {
  margin-bottom: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 6px;
}

.detail-summary h4 {
  margin: 0 0 8px 0;
  color: #303133;
}

.detail-summary p {
  margin: 0;
  color: #666;
  font-size: 14px;
}

.report-detail h5 {
  margin: 0 0 10px 0;
  color: #409eff;
  font-size: 14px;
  font-weight: 600;
  padding-left: 5px;
  border-left: 3px solid #409EFF;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .monthly-report-container {
    padding: 12px;
  }
  
  .page-header {
    padding: 16px;
    margin-bottom: 12px;
  }
  
  .header-content h2 {
    font-size: 18px;
  }
  
  .el-card .el-card__body {
    padding: 20px 16px;
  }
  
  .time-input-group {
    padding: 12px;
    gap: 8px;
  }
  
  .time-label {
    font-size: 12px;
    margin-bottom: 4px;
  }
  
  .time-separator {
    font-size: 18px;
    margin-bottom: 12px;
  }
  
  .submit-section {
    padding: 24px 16px;
    margin-top: 24px;
  }
  
  .submit-section .el-button-group {
    flex-direction: column;
    gap: 12px;
  }
  
  .submit-section .el-button {
    width: 100%;
    min-width: auto;
  }
  
  .validation-info {
    padding: 10px 12px;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
  
  .calculated-value {
    font-size: 12px;
  }
  
  .sync-btn {
    align-self: flex-end;
  }
  
  .label {
    font-size: 13px;
  }
  
  .value {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .monthly-report-container {
    padding: 8px;
  }
  
  .time-input-group {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 16px;
  }
  
  .time-input-wrapper {
    width: 100%;
  }
  
  .time-separator {
    align-self: center;
    margin: 8px 0;
    font-size: 16px;
  }
  
  .el-form-item__label {
    font-size: 13px;
  }
  
  .submit-section .el-button {
    padding: 12px 24px;
    font-size: 15px;
  }
}
</style>